// src/store/index.js 状态管理
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: sessionStorage.getItem('token') || '',
    admin: JSON.parse(sessionStorage.getItem('admin') || 'null')
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      sessionStorage.setItem('token', token);
    },
    setAdmin(state, admin) {
      state.admin = admin;
      sessionStorage.setItem('admin', JSON.stringify(admin));
    },
    logout(state) {
      state.token = '';
      state.admin = null;
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('admin');
    }
  }
});
